import React, { Component, Fragment } from 'react';
import i18n from '../../../plugins/i18n/i18n'
import { actions } from '../../../store/modules';
import { connect } from 'react-redux';
import { Form, Button, Input } from 'antd'

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSend: false,
      loading: false,
      loginSuccess: null,
      errorMessage: null
    }
  }

  fetch = (values) => {

    this.setState({
      loading: true
    })

    var param = {
      email: values.email,
    }

    this.props.dispatch(actions.auth.forgotPassword(param))
      .then(() => this.setState({
        isSend: true,
        loading: false
      }))
      .catch(error => {

        let responseErrorMessage = (error && error.errors && error.errors[0].error && error.errors[0].error) || (error && error.description && error.description) || (i18n.t('unknownErrorOccurred', { lng: this.props.currentLanguage }));

        this.setState(
          {
            loading: false,
            loginSuccess: false,
            errorMessage: responseErrorMessage

          },
          () => {
            setTimeout(() => {
              this.setState({ loginSuccess: null });
            }, 3500);
          })
      })
  }



  render() {

    let { loading, loginSuccess, errorMessage } = this.state;

    return (

      <div className="auth-content">

        <h1 className="heading">
          Şifrenizi sıfırlamak için e-posta adresinizi giriniz
        </h1>
        <div className='form-box'>
          <Form layout="vertical"
            onFinish={this.fetch}
          >

            {
              !this.state.isSend ?
                <Fragment>

                  <Form.Item
                    label={`${i18n.t("email", {
                      lng: this.props.currentLanguage,
                    })}`}
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: i18n.t("emailInvalid")
                      },
                      {
                        required: true,
                        message: `${i18n.t("fieldIsRequired", {
                          lng: this.props.currentLanguage,
                        })}`,
                      }
                    ]}
                  >
                    <Input
                      type="email"
                      placeholder="e-posta@alanadi.com"
                    />
                  </Form.Item>

                  <div
                    className="error"
                    style={
                      loginSuccess === false
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    {errorMessage}
                  </div>
                  <Form.Item>
                    <Button
                      className="width-100 mt-20"
                      htmlType="submit"
                      type="primary"
                      loading={loading}
                    >
                      {i18n.t('send', { lng: this.props.currentLanguage })}
                    </Button>
                  </Form.Item>

                </Fragment>
                :
                <Form.Item>
                  <p style={{ fontSize: 16 }}>{i18n.t('helpIsOnTheWayLabel', { lng: this.props.currentLanguage })}</p>
                </Form.Item>
            }

          </Form>
        </div>

        <div className='form-box'>
          <Form layout="vertical">
            <Form.Item>
              <Button
                className="width-100"
                htmlType="submit"
                type="default"
                onClick={() => this.props.history.push(
                  `/auth/sign-in`
                )}
              >
                Farklı bir hesap ile oturum açın
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

    )
  }
}

const mapStateToProps = ({ auth }) => ({
  ...auth
});
export default connect(mapStateToProps)(ForgotPassword);






// WEBPACK FOOTER //
// ./src/components/Auth/Views/ForgotPassword.js